import {Vue, Component} from 'vue-property-decorator'
import {withoutAuthAxiosWS} from '@/network/network';
import Loader from "@/components/loader/Loader.vue";
import 'vue-toasted';

@Component({
	components: {Loader}
})

export default class Contactus extends Vue {
   

	public emails: string[] = ['demo-team@rixtrema.com', 'support@rixtrema.com'];
    public name: string = '';
    public email: string = '';
	public formattedPhoneValue: string = '';
    public phone: string = '';
	public validPhone: boolean = false;

	public loading = false;

	get activeButton(){

		return Boolean(this.name && this.email && this.phone);
	}

	get buttonClass(){

		return this.activeButton ? 'enabled' : 'disabled';
	}

	focusOutPhone(){

		
		if (this.formattedPhoneValue){

			const newValue = this.formattedPhoneValue.replace(/-/g, '').match(/(\d{1,10})/g)

			if (newValue){
			this.phone = newValue[0];
			}
			// Format display value based on calculated currencyValue
			this.formattedPhoneValue = this.phone.replace(/(\d{1,3})(\d{1,3})(\d{1,4})/g, '$1-$2-$3');
			
		}

		this.validPhone = this.formattedPhoneValue.length === 12;
	

	}

	createLetter(mailTo: string){


		const mailMessage = encodeURIComponent(
			"Demo request:<br>" + this.name + ", <br>\
			email: " + this.email + " <br>\
			phone: " + this.phone+" <p>\
			<p>Sincerely,\
			<br>" + 'Rixtrema Inc.'
		);


		var sendl = {
			action : 'SENDMAIL',
			nameFrom: 'extrem24@mail.rixtrema.com',
			mailFrom: 'extrem24@mail.rixtrema.com',
			MailTo: mailTo,
			mailCopy: 'asys@rixtrema.com',
			MailSubject: 'Demo request Advisor TechMarket',
			MailMessage: mailMessage
		}

		return sendl



	}

	send(){

		if (this.activeButton){
			this.loading = true;
			this.sendLetter(
				this.emails.map(email => this.createLetter(email)), 
				sent => {
	
					console.log('sent', sent)
					this.loading = false;
					this.$router.push('/thankyou?noproduct=true')
	
				}, (err) => {
	
					console.log('error', err);
					this.loading = false;
					this.$toasted.error('Something wrong. Please, try again later.', {
						duration: 4000
					});	

	
				}
			)
		}

	}

	sendLetter(mails: any[], success, handleError){
	
		
		Promise.all(
			mails.map(mail => this.sendLetterToRixtrema(mail))
		)
		.then(success)
		.catch(handleError)

	
  
	}
  
	sendLetterToRixtrema(data: any){
  
		const formData = new FormData()

		for (const idx in data){

			formData.append(idx, data[idx])
		}


		return withoutAuthAxiosWS.post('/AJAXBIONIX.aspx', formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		})
	}




}